import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import ImageLoad from 'components/ImageLoad';
import TagManagerService from 'services/TagManager';
import style from './style.scss'; //NOSONAR

const Item = ({ item, position, title, gtmData }) => {

    if(!item) return '';

    const imageMobile = item.image_mobile ? item.image_mobile : '';
    const imageDesktop = item.image_desktop ? item.image_desktop : '';

    const imageResponsive = {
        768: imageMobile  ? imageMobile.url : '',
        1440: imageDesktop ? imageDesktop.url : ''
    };

    const altDescription = imageDesktop.alt || imageMobile.alt;

    const tagPromotionsClick = (itemJw, positionJw, creative) => {
        TagManagerService.promotionsClick(itemJw, positionJw, creative);
    };



    return (
        <Link className="jumbo-world-item-container" target={item.url_target} to={item.url} onClick={() => tagPromotionsClick(item, position, title)}>
            <ImageLoad className="jumbo-world-item-image" srcSet={imageResponsive} src={imageDesktop.url} alt={altDescription} gtmData={gtmData} />
            <h2 className="jumbo-world-item-title">{item.title}</h2>
            <h3 className="jumbo-world-item-subtitle">{item.subtitle}</h3>
        </Link>
    )
};

Item.propTypes = {
    item: PropTypes.object,
    position: PropTypes.string,
    title: PropTypes.string,
    gtmData: PropTypes.object,
};

export default Item;
